import { BehaviorSubject, combineLatest, map, Observable } from 'rxjs';

import { Injectable } from '@angular/core';

import { AlertLevel, UserNotification } from '../models/user.model';

const mockNotifications: UserNotification[] = [
  {
    message: 'Something happened!',
    createdDate: new Date(2023, 0, 0),
    level: 'unack'
  },
  {
    message: 'Something happened again!',
    createdDate: new Date(Date.now() - 1000 * 60 * 60 * 2),
    level: 'critical'
  },
  {
    message: 'Something might happen again!',
    createdDate: new Date(2023, 0, 8),
    level: 'warning'
  },
  {
    /* eslint-disable-next-line max-len */
    message:
      'Something minor happened. This is a longer message with more details and things to know. Sometimes you need to know more than a single sentence of information.',
    createdDate: new Date(2023, 1, 0),
    level: 'info'
  },
  {
    message: 'Something minor happened again.',
    createdDate: new Date(2023, 1, 15),
    level: 'critical'
  },
  {
    message: 'Something DID happen again!',
    createdDate: new Date(),
    level: 'warning'
  },
  {
    message: 'Something DID happen again!',
    createdDate: new Date(Date.now() - 1000 * 60 * 60 * 4),
    level: 'warning'
  },
  {
    message: 'Something minor happened again.',
    createdDate: new Date(2023, 1, 15),
    level: 'unack'
  },
  {
    message: 'Something DID happen again!',
    createdDate: new Date(),
    level: 'unack'
  },
  {
    message: 'Something DID happen again!',
    createdDate: new Date(Date.now() - 1000 * 60 * 10),
    level: 'critical'
  }
].map(
  (item) =>
    ({
      ...item,
      id: `${Math.floor(Math.random() * 1000000)}`
    }) as UserNotification
);

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  notifications$: BehaviorSubject<UserNotification[]> = new BehaviorSubject<
    UserNotification[]
  >([]);
  lastReadNotificationTime$: BehaviorSubject<number> =
    new BehaviorSubject<number>(
      +(localStorage.getItem('lastReadNotificationTime') ?? 0)
    );
  hasUnreadNotifications$: Observable<boolean>;
  isFetchingData$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  constructor() {
    this.hasUnreadNotifications$ = combineLatest([
      this.notifications$,
      this.lastReadNotificationTime$
    ]).pipe(
      map(([notifications, lastReadNotificationTime]) =>
        notifications.some(
          (notification) =>
            notification.createdDate.getTime() > lastReadNotificationTime
        )
      )
    );
  }

  updateLatestNotificationTime() {
    this.lastReadNotificationTime$.next(
      Math.max(
        ...this.notifications$
          .getValue()
          .map(({ createdDate }) => createdDate.getTime())
      )
    );
    localStorage.setItem(
      'lastReadNotificationTime',
      this.lastReadNotificationTime$.getValue() + ''
    );
  }

  fetchInitialNotifications() {
    this.isFetchingData$.next(true);
    setTimeout(() => {
      this.isFetchingData$.next(false);
      this.notifications$.next(mockNotifications);
    }, 1000);
  }

  fetchNotifications() {
    this.isFetchingData$.next(true);
    setTimeout(() => {
      const newNotifications: UserNotification[] = [];
      const levels: AlertLevel[] = ['critical', 'warning', 'info', 'unack'];

      for (let i = 0; i < Math.floor(Math.random() * 4); i++) {
        newNotifications.push({
          message: 'Text text text text',
          createdDate: new Date(),
          level: levels[Math.floor(Math.random() * 4)],
          id: `${Math.floor(Math.random() * 1000000)}`
        });
      }
      this.notifications$.next([
        ...newNotifications,
        ...this.notifications$.getValue()
      ]);
      this.isFetchingData$.next(false);
    }, 1000);
  }
}
